import React from 'react';

import type {CommonIconProps} from '../types';

const ShortDotLineIcon: React.FC<CommonIconProps> = ({height, width}: CommonIconProps) => (
    <svg
        width={width}
        height={height}
        fill="none"
        viewBox="0 2 38 2"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-2 4h-1V2h1v2zm4 0H0V2h2v2zm4 0H4V2h2v2zm4 0H8V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm4 0h-2V2h2v2zm3 0h-1V2h1v2z"
            fill="currentColor"
        />
    </svg>
);

export default ShortDotLineIcon;
